/*  app.js
    Offers access to Google firebase/firestore
    by Guy E. White <guw968@g.harvard.edu>

    To Do: Add authorization and security.
*/

import Api from '@/common/api.js';
export { default as MyTests } from '@/common/MyTests.js'

export const config = {
    firebase: {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID
    }
}

/* eslint-disable */
console.log(process.env.VUE_APP_FIREBASE_PROJECT_ID);
/* eslint-enable */

export const api = new Api({
    apiKey: config.firebase.apiKey,
    projectId: config.firebase.projectId
});

// State Management - Single Source of Truth
export let store = {
    mytestsCount: 0
}
